import { uouTagClickedEvent } from '../../common/bi-events/uou-events/uou-tag-clicked-event';

export const eventMap = {
  ...uouTagClickedEvent,
};
